import { store, useAppSelector } from "store/index";
import { viewStateActions } from "store/slices/view";

// Requests outlive the Groups panel. Reopening it must not enable conflicting edits.
export const usePageGroupOperation = (pageId: string) => {
  const isPending = useAppSelector((state) => !!state.view.pendingPageGroupActions[pageId]);
  const runPageGroupOperation = async <T>(operation: () => Promise<T>) => {
    if (store.getState().view.pendingPageGroupActions[pageId]) return;
    store.dispatch(viewStateActions.setPageGroupActionPending({ pageId, pending: true }));
    try {
      return await operation();
    } finally {
      store.dispatch(viewStateActions.setPageGroupActionPending({ pageId, pending: false }));
    }
  };
  return { isPending, runPageGroupOperation };
};
